import React from "react";

const formatLog = (log) => {
  if (!log) return "";
  return log
    .split("\n")
    .map((line) => {
      const trimmed = line.trim();
      if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
        try {
          return JSON.stringify(JSON.parse(trimmed), null, 2);
        } catch {
          return line;
        }
      }
      return line;
    })
    .join("\n");
};

const LogDisplay = ({ log }) => {
  return (
    <pre
      style={{
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        overflowWrap: "anywhere",
        margin: 0,
      }}
    >
      {formatLog(log)}
    </pre>
  );
};

export default LogDisplay;
